import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=5c898afd&scoped=true&"
import script from "./Booking.vue?vue&type=script&lang=ts&"
export * from "./Booking.vue?vue&type=script&lang=ts&"
import style0 from "./Booking.vue?vue&type=style&index=0&id=5c898afd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c898afd",
  null
  
)

export default component.exports